import type { CSSProperties } from 'react'
import { cn } from '../lib'
import { designTokens } from '../lib/design-tokens'

type ToggleProps = {
  checked: boolean
  onChange: (next: boolean) => void
  disabled?: boolean
  className?: string
}

export function Toggle({ checked, onChange, disabled = false, className }: ToggleProps) {
  const trackWidth = designTokens.spacing.adminToggleWidth
  const trackHeight = designTokens.spacing.adminToggleHeight
  const thumbSize = designTokens.spacing.adminToggleThumb
  const trackPadding = designTokens.spacing.adminTogglePadding
  const thumbTranslate = checked
    ? `calc(${trackWidth} - ${thumbSize} - ${trackPadding} - ${trackPadding})`
    : designTokens.spacing.none
  const trackStyle: CSSProperties & { [key in `--control-${string}`]?: string } = {
    '--control-ring': designTokens.colors.border.inputFocus,
    '--control-ring-offset': designTokens.colors.background.surface,
    width: trackWidth,
    height: trackHeight,
    padding: trackPadding,
    background: checked
      ? designTokens.colors.status.adminToggleOn
      : (designTokens.colors.border.adminSoft ?? designTokens.colors.border.default),
    borderRadius: designTokens.borders.radius.pill,
  }
  const thumbStyle: CSSProperties = {
    width: thumbSize,
    height: thumbSize,
    transform: `translateX(${thumbTranslate})`,
    background: designTokens.colors.neutral.white,
    borderRadius: designTokens.borders.radius.pill,
  }

  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={() => onChange(!checked)}
      className={cn(
        'relative inline-flex items-center border border-transparent p-0 transition focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[var(--control-ring)] focus-visible:ring-offset-2 focus-visible:ring-offset-[var(--control-ring-offset)]',
        disabled ? 'cursor-not-allowed opacity-50' : 'cursor-pointer',
        className
      )}
      style={trackStyle}
    >
      <span className="inline-block transition-transform" style={thumbStyle} />
    </button>
  )
}
